var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lmnc-form-section"},[_c('div',{staticClass:"section"},[(_vm.title)?_c('div',[_c('h2',[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._t("default")],2),(_vm.divider)?_c('v-divider',{staticClass:"divider"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }